export default "__VITE_ASSET__a15adb8d__"